const GhostCardContainer = ({ children, className = "" }) => {
  return <div className={`ghost-card-shell ${className}`}>{children}</div>;
};

export default GhostCardContainer;
